module.exports = __webpack_public_path__ + "ac54637253d6ccec5c84db3972b9ddb5.png";